<template>
  <div class="container">
    <div class="block">
      <!-- <div class="title-wrap">
        <div class="title-name">
          <label>{{title_prefix}}认证工作室</label>
        </div>
      </div> -->
      <div class="content-inner-wrap">
        <div class="applyProgressPanel" v-if="status === 1">
          <i class="icon-unpass"></i>
          <h3>审核未通过</h3>
          <p class="text reason">请提供有效的营业执照</p>
          <p class="text reason">
            若有任何疑问，请联系邮箱：developer@mini1.cn
          </p>
          <p class="text reason">
            更多详情请阅读<a
              class="el-link"
              type="primary"
              href="https://mnweb.mini1.cn/activity/docs/operate_rule_V1_A20210520.html"
              target="_blank"
              >《迷你世界工作室运营规范》</a
            >
          </p>
          <van-button
            id="applyAgain"
            class="largeBtn"
            @click="status = 3"
            type="primary"
            >重新申请</van-button
          >
        </div>
        <div class="applyProgressPanel" v-else-if="status === 2">
          <i class="icon-appling"></i>
          <h3>认证审核中</h3>
          <p class="text">
            官方会在5个工作室内审核您的申请<br />请留意邮箱内邮件或短信，若有疑问请联系QQ群12319238192
          </p>
          <van-button
            @click="$router.push({ name: 'Studio' })"
            class="largeBtn"
            type="primary"
            >确定</van-button
          >
        </div>
        <div class="applyStepsPanel" v-else>
          <van-steps :active="step">
            <van-step>
              <template v-slot:active-icon>
                <i class="icon-step icon-step-active-icon"></i>
              </template>
              <template v-slot:inactive-icon>
                <i class="icon-step icon-step-inactive-icon"></i>
              </template>
              <template v-slot:finish-icon>
                <i class="icon-step icon-step-finish-icon"></i>
              </template>
              填写公司信息
            </van-step>
            <van-step>
              <template v-slot:active-icon>
                <i class="icon-step icon-step-active-icon"></i>
              </template>
              <template v-slot:inactive-icon>
                <i class="icon-step icon-step-inactive-icon"></i>
              </template>
              <template v-slot:finish-icon>
                <i class="icon-step icon-step-finish-icon"></i>
              </template>
              填写法人信息
            </van-step>
            <van-step>
              <template v-slot:active-icon>
                <i class="icon-step icon-step-active-icon"></i>
              </template>
              <template v-slot:inactive-icon>
                <i class="icon-step icon-step-inactive-icon"></i>
              </template>
              <template v-slot:finish-icon>
                <i class="icon-step icon-step-finish-icon"></i>
              </template>
              填写结算信息
            </van-step>
          </van-steps>
          <div class="stepContent applyStep1" v-show="step === 0">
            <van-form
              :label-position="'right'"
              label-width="90px"
              @submit="handleNextClicked"
              :show-error="false"
              validate-first
              validate-trigger="onSubmit"
              :model="step1Form"
              ref="step1Form"
            >
              <van-field
                label="公司全称"
                placeholder="请填写公司全称"
                name="company_name"
                v-model="step1Form.company_name"
                :rules="step1Rule.company_name"
              >
              </van-field>
              <van-field
                label="营业执照注册号"
                name="company_id"
                placeholder="请填写营业执照注册号"
                v-model="step1Form.company_id"
                :rules="step1Rule.company_id"
              >
              </van-field>
              <van-field
                label="营业执照"
                name="fileList"
                v-model="step1Form.fileList"
                :rules="[
                  {
                    type: 'array',
                    validator: validatorImg,
                    required: true,
                    message: '请上传公司营业执照照片或扫描件图片',
                    trigger: 'onChange',
                  },
                ]"
              >
                <template slot="input">
                  <my-el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-remove="s1FormHandleRemove"
                    :on-change="s1FormOnChange"
                    :file-list="fileList1"
                    :before-upload="onBeforeUpload"
                    name="image"
                    accept="image/png,image/jpeg,image/bmp"
                    list-type="picture"
                  >
                    <van-button
                      size="small"
                      class="uploadBtn"
                      native-type="button"
                      ><i class="icon icon-upload"></i
                      ><span>上传文件</span></van-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      <p>请上传公司营业执照照片或扫描件图片</p>
                      <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                    </div>
                  </my-el-upload>
                </template>
              </van-field>
              <van-button
                class="largeCenterBtn"
                type="primary"
                native-type="submit"
                >下一步</van-button
              >
            </van-form>
          </div>
          <div class="stepContent applyStep2" v-show="step === 1">
            <van-form
              :label-position="'right'"
              @submit="handleNextClicked"
              :show-error="false"
              validate-first
              validate-trigger="onSubmit"
              label-width="90px"
              :model="step2Form"
              ref="step2Form"
            >
              <van-field
                name="boss_name"
                :rules="step2Rule.boss_name"
                label="法人名字"
                placeholder="请填写法人名字"
                v-model="step2Form.boss_name"
                prop="boss_name"
              >
              </van-field>
              <van-field
                name="boss_id"
                :rules="step2Rule.boss_id"
                placeholder="请填写法人身份证号"
                v-model="step2Form.boss_id"
                label="法人身份证号"
                prop="boss_id"
              >
              </van-field>
              <van-field
                label="法人身份证信息"
                name="fileList"
                v-model="step2Form.fileList"
                :rules="[
                  {
                    type: 'array',
                    validator: validatorImg,
                    count: 2,
                    required: true,
                    message: '请上传公司法人身份证正反面照片',
                    trigger: 'onChange',
                  },
                ]"
              >
                <template slot="input">
                  <my-el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-remove="s2FormHandleRemove"
                    :on-change="s2FormOnChange"
                    :file-list="fileList2"
                    :before-upload="onBeforeUpload"
                    name="image"
                    accept="image/png,image/jpeg,image/bmp"
                    list-type="picture"
                  >
                    <van-button
                      size="small"
                      class="uploadBtn"
                      native-type="button"
                      ><i class="icon icon-upload"></i
                      ><span>上传文件</span></van-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      <p>请上传法人身份证正反面照片或扫描件图片</p>
                      <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                    </div>
                  </my-el-upload>
                </template>
              </van-field>
              <van-button
                class="largeCenterBtn"
                type="primary"
                native-type="submit"
                >下一步</van-button
              >
            </van-form>
            <van-button
              class="largeCenterBtn stepLastBtn"
              @click="handlePrevClicked"
              type="primary"
              >上一步</van-button
            >
          </div>
          <div class="stepContent applyStep3" v-show="step === 2">
            <van-form
              :label-position="'right'"
              @submit="handleNextClicked"
              :show-error="false"
              validate-first
              validate-trigger="onSubmit"
              label-width="80px"
              :model="step3Form"
              ref="step3Form"
            >
              <van-field
                name="bank_card"
                :rules="step3Rule.bank_card"
                placeholder="请填写公司的银行卡号"
                v-model="step3Form.bank_card"
                label="银行卡号"
                prop="bank_card"
              >
              </van-field>
              <van-field
                name="bank_name"
                :rules="step3Rule.bank_name"
                placeholder="请填写公司的银行卡所属银行"
                v-model="step3Form.bank_name"
                label="所属银行"
                prop="bank_name"
              >
              </van-field>
              <van-field
                name="bank_branch"
                :rules="step3Rule.bank_branch"
                placeholder="请填写公司的银行卡所属支行"
                v-model="step3Form.bank_branch"
                label="所属支行"
                prop="bank_branch"
              >
              </van-field>
              <van-field
                name="phone"
                :rules="step3Rule.phone"
                placeholder="请填写公司的银行卡联系电话"
                v-model="step3Form.phone"
                label="联系电话"
                prop="phone"
              >
              </van-field>
              <van-field
                name="fileList"
                v-model="step3Form.fileList"
                label="账户凭证"
                :rules="step3Rule.fileList"
              >
                <template slot="input">
                  <my-el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-remove="s3FormHandleRemove"
                    :on-change="s3FormOnChange"
                    :file-list="fileList3"
                    :before-upload="onBeforeUpload"
                    name="image"
                    accept="image/png,image/jpeg,image/bmp"
                    list-type="picture"
                  >
                    <van-button
                      size="small"
                      class="uploadBtn"
                      native-type="button"
                      ><i class="icon icon-upload"></i
                      ><span>上传文件</span></van-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      <p>
                        请上传以公司名义开立的基本存款账户信息凭证，如开户许可证照片等
                      </p>
                      <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                    </div>
                  </my-el-upload>
                </template>
              </van-field>
              <van-button
                class="largeCenterBtn"
                type="primary"
                native-type="submit"
                >提交信息</van-button
              >
            </van-form>
            <van-button
              class="largeCenterBtn stepLastBtn"
              @click="handlePrevClicked"
              type="primary"
              >上一步</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyUpload from '../../../../components/MyUpload.vue';
import {
  studioRequestVip,
  studioChangeVip,
  getStudioDetail,
  checkStudioRegisterStatus,
} from '@/api/studio';
import {
  UPLOAD_URL,
  isValidTel,
  isValidPhone,
  isValidFileSize,
} from '../../CONST';
export default {
  components: {
    [MyUpload.name]: MyUpload,
  },
  data() {
    return {
      studioBaseInfo: null,
      title_prefix: '成为',
      uploadUrl: UPLOAD_URL,
      // 1, 审核未通过； 2, 审核中； 3, 审核已通过
      status: 0,
      step: 0,
      step1Form: {
        company_name: '',
        company_id: '',
        fileList: '',
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      step2Form: {
        boss_name: '',
        boss_id: '',
        fileList: '',
      },
      step3Form: {
        bank_card: '',
        bank_name: '',
        bank_branch: '',
        phone: '',
        fileList: '',
      },
      step1Rule: {
        company_name: [
          {
            required: true,
            message: '请填写公司名称',
            trigger: 'onBlur',
            'show-error-message': false,
          },
          {
            min: 4,
            max: 50,
            message: '长度在 4 到 50 个字符',
            trigger: 'onBlur',
          },
        ],
        company_id: [
          {
            required: true,
            message: '请填写营业执照注册号',
            trigger: 'onBlur',
            pattern: /(^[A-Za-z0-9_]{15}$)|(^[A-Za-z0-9_]{18}$)/,
          },
        ],
        fileList: [
          {
            type: 'string',
            validator: this.validatorImg,
            required: true,
            message: '请上传公司营业执照照片或扫描件图片',
            trigger: 'onChange',
          },
        ],
      },
      step2Rule: {
        boss_name: [
          { required: true, message: '请填写法人名字', trigger: 'onBlur' },
          {
            min: 2,
            max: 50,
            message: '长度在 2 到 50 个字符',
            trigger: 'onBlur',
          },
        ],
        boss_id: [
          {
            required: true,
            message: '请填写法人身份证号码',
            trigger: 'onBlur',
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          },
        ],
        fileList: [
          {
            type: 'string',
            required: true,
            message: '请上传公司法人身份证正反面照片',
            trigger: 'onChange',
          },
        ],
      },
      step3Rule: {
        bank_card: [
          {
            required: true,
            message: '请填写银行卡号码',
            trigger: 'onBlur',
            max: 25,
            min: 8,
          },
        ],
        bank_name: [
          { required: true, message: '请填写银行名称', trigger: 'onBlur' },
          {
            min: 2,
            max: 50,
            message: '长度在 2 到 50 个字符',
            trigger: 'onBlur',
          },
        ],
        bank_branch: [
          {
            required: true,
            message: '请填写所属银行支行名称',
            trigger: 'onBlur',
          },
          {
            min: 2,
            max: 50,
            message: '长度在 2 到 50 个字符',
            trigger: 'onBlur',
          },
        ],
        phone: [
          {
            required: true,
            validator: this.validatorContact,
            message: '请填写公司的银行卡联系电话',
            trigger: 'onBlur',
          },
        ],
        fileList: [
          {
            type: 'string',
            required: true,
            message: '请上传以公司名义开立的银行卡正面照片或扫描件照片',
            trigger: 'onChange',
          },
        ],
      },
    };
  },
  async mounted() {
    const IS_UPDATE = this.$route.params.requestType === 'update';
    if (IS_UPDATE) {
      this.title_prefix = '修改';
      let studioBaseInfo = sessionStorage.getItem('studioBaseInfo');
      if (studioBaseInfo) {
        this.studioBaseInfo = JSON.parse(studioBaseInfo);
      } else {
        const res = await getStudioDetail({ json: 1 });
        this.studioBaseInfo = res.data;
        sessionStorage.setItem(
          'studioBaseInfo',
          JSON.stringify(this.studioBaseInfo),
        );
      }
      let {
        company_name,
        company_id,
        company_image,
        boss_name,
        boss_id,
        boss_id_front,
        boss_id_back,
        bank_card,
        bank_name,
        bank_branch,
        phone,
        bank_card_front,
      } = this.studioBaseInfo;
      this.fileList1 = [{ name: '营业执照', url: company_image }];
      this.step1Form = {
        company_name,
        company_id,
        fileList: JSON.stringify(this.fileList1),
      };
      this.fileList2 = [
        { name: '身份证正面', url: boss_id_front },
        { name: '身份证反面', url: boss_id_back },
      ];
      this.step2Form = {
        boss_name,
        boss_id,
        fileList: JSON.stringify(this.fileList2),
      };
      this.fileList3 = [{ name: '银行卡正面照', url: bank_card_front }];
      this.step3Form = {
        bank_card,
        bank_name,
        bank_branch,
        phone,
        fileList: JSON.stringify(this.fileList3),
      };
    }
  },
  created() {
    checkStudioRegisterStatus({ json: 1 }).then(res => {
      let { is_vip_audit_approving, is_vip_audit_rejected } = res.data;
      if (is_vip_audit_rejected) {
        this.status = 1;
      } else if (is_vip_audit_approving) {
        this.status = 2;
      } else {
        this.status = 3;
      }
    });
  },
  methods: {
    onBeforeUpload(file) {
      return isValidFileSize(file.size, () =>
        this.$toast.fail('请限制文件大小在10M以内'),
      );
    },
    validatorImg(files, rule) {
      let { count } = rule;
      if (!count) count = 1;
      if (typeof files === 'string') files = JSON.parse(files);
      if (files.length === count) {
        return true;
      } else {
        this.$toast.fail(`超出限制，请上传不多于${count}张图片`);
        return false;
      }
    },
    validatorContact(value) {
      return isValidTel(value) || isValidPhone(value);
    },
    handleNextClicked(values) {
      const stepForm = this[`step${1 + this.step}Form`];
      const stepRule = this[`step${1 + this.step}Rule`];
      const requestFn =
        this.studioBaseInfo && this.studioBaseInfo.vip
          ? studioChangeVip
          : studioRequestVip;
      // const requestFn = studioRequestVip;
      let hasSomeValUnfilled = false;
      for (let key in values) {
        if (values[key]) {
          stepForm[key] = values[key];
        } else {
          hasSomeValUnfilled = true;
          this.$toast.fail(stepRule[key].message);
        }
      }
      if (hasSomeValUnfilled) {
        return;
      } else {
        if (this.step === 2) {
          let { company_name, company_id } = this.step1Form;
          let company_image = JSON.parse(this.step1Form.fileList)[0].url;
          let { boss_name, boss_id } = this.step2Form;
          let step2FormFileList = JSON.parse(this.step2Form.fileList);
          let boss_id_front = step2FormFileList[0].url;
          let boss_id_back = step2FormFileList[1].url;
          let { bank_card, bank_name, bank_branch, phone } = this.step3Form;
          let bank_card_front = JSON.parse(this.step3Form.fileList)[0].url;
          requestFn({
            company_name,
            company_id,
            company_image,
            boss_name,
            boss_id,
            boss_id_front,
            boss_id_back,
            bank_card,
            bank_name,
            bank_branch,
            phone,
            bank_card_front,
            json: 1,
          }).then(res => {
            if (res.code === 0) {
              this.step++;
              this.$toast.success('提交申请成功，请等待审核后生效');
              this.status = 2;
            }
          });
        } else {
          this.step++;
        }
      }
    },
    handlePrevClicked() {
      this.step--;
    },
    s1FormOnChange(file) {
      this.formOnchange(file, 1);
    },
    s2FormOnChange(file) {
      this.formOnchange(file, 2);
    },
    s3FormOnChange(file) {
      this.formOnchange(file, 3);
    },
    formOnchange(file, index) {
      let { status, response, name } = file;
      let temp = [];
      const currForm = this[`step${index}Form`];
      let currFileList = this[`fileList${index}`];
      if (currForm.fileList) {
        let _fileList = JSON.parse(currForm.fileList);
        if (_fileList instanceof Array) {
          temp = _fileList;
        } else {
          if (index == 2) {
            temp.push(_fileList);
          } else {
            temp = [_fileList];
          }
        }
      }
      if (status === 'success' && response.code === 200) {
        let obj = { name, url: response.data.image.cdn_url };
        if (index === 2) {
          if (temp.length >= 2) {
            currFileList.shift();
            temp.shift();
          }
          temp.push(obj);
        } else {
          temp = [obj];
          currFileList.shift();
        }
        currFileList.push(obj);
        currForm.fileList = JSON.stringify(temp);
        console.log('last', index, temp, currFileList, currForm.fileList);
        console.log(this.fileList1, this.fileList2, this.fileList3);
      }
    },
    s1FormHandleRemove(file) {
      this.formHandleRemove(file, 1);
    },
    s2FormHandleRemove(file) {
      this.formHandleRemove(file, 2);
    },
    s3FormHandleRemove(file) {
      this.formHandleRemove(file, 3);
    },
    formHandleRemove(file, index) {
      let { name } = file;
      let rmIndex = -1;
      const stepForm = `step${index}Form`;
      this[stepForm].fileList.forEach((val, index) => {
        if (val.name === name) rmIndex = index;
      });
      if (rmIndex > -1) {
        this[stepForm].fileList.splice(rmIndex, 1);
      }
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.container .block {
  min-height: calc(100vh - 110px);
  .icon-unpass,
  .icon-appling {
    display: block;
    width: 160px;
    height: 160px;
    margin: 280px auto 82px;
    background: url('../../../../assets/images/icon-unpass.svg') 0 0 no-repeat;
    background-size: 120px;
  }
  .icon-appling {
    background-image: url('../../../../assets/images/icon-appling.svg');
  }
  h3 {
    font-size: 40px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #262626;
    line-height: 52px;
    text-align: center;
    margin-bottom: 24px;
  }
  .text {
    font-size: 24px;
    line-height: 40px;
    color: #8c8c8c;
    text-align: center;
    .el-link {
      color: #2b6ddf;
    }
  }
  .largeBtn,
  .largeCenterBtn {
    display: block;
    margin: 120px auto 40px;
    width: 502px;
    height: 70px;
    background: #fd9b21;
    border-radius: 8px;
    font-size: 28px;
    line-height: 38px;
    &.stepLastBtn {
      background: #d9d9d9;
      border-color: #d9d9d9;
      margin-top: 0;
    }
  }
  .applyStepsPanel {
    width: 678px;
    margin: auto;
    .applyStep1 {
      .upload-demo {
        ::v-deep .el-upload-list__item-thumbnail {
          width: 156px;
          height: 220px;
        }
      }
    }
    .applyStep2,
    .applyStep3 {
      .upload-demo {
        ::v-deep .el-upload-list__item-thumbnail {
          width: 222px;
          height: 140px;
        }
      }
    }
    .upload-demo {
      ::v-deep .el-upload-list.el-upload-list--picture {
        height: auto;
        overflow: hidden;
        .el-upload-list__item {
          height: auto;
          width: auto;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
<style lang="less">
.container .block .content-inner-wrap .applyStepsPanel {
  .icon-step {
    width: 44px;
    height: 44px;
    display: block;
    // background: url(~@/assets/images/step-inactive-icon.png) 0 0 no-repeat;
    background-position: 0;
    background-repeat: no-repeat;
    background-size: 44px;
  }
  .icon-step.icon-step-active-icon {
    background-image: url(~@/assets/images/step-active-icon.png);
  }
  .icon-step.icon-step-inactive-icon {
    background-image: url(~@/assets/images/step-inactive-icon.png);
  }
  .icon-step.icon-step-finish-icon {
    background-image: url(~@/assets/images/step-finish-icon.png);
  }
  .van-step--finish {
    .van-step__title {
      color: #6bb85b;
    }
  }
  .van-step--horizontal {
    .van-step__line {
      background-color: #bfbfbf;
      height: 2px;
    }
  }
  .van-step--process {
    .van-step__line {
      background-color: #bfbfbf;
      height: 2px;
    }
    .van-step__title {
      color: #fd9b21;
    }
  }
  .van-step--finish {
    .van-step__line {
      background-color: #6bb85b;
      height: 2px;
    }
  }
}
</style>
<style lang="less">
.van-steps {
  overflow: visible;
  margin-top: 100px;
}
.van-step--horizontal .van-step__line,
.van-step--horizontal .van-step__circle-container {
  top: -30px;
}
.van-step--horizontal .van-step__title {
  font-size: 24px;
  line-height: 32px;
}
</style>
